'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@7f-ui/components/button/button';
import { IconButton } from '@7f-ui/components/button/icon-button';
import { Popup } from '@7f-ui/components/popup';
import type { GetRecommendationFragment } from '@data-access/lib/gql/cart/documents';
import { trackClickCta } from '@feat/feat-tracking/cta';
import { CheckCircle } from '@phosphor-icons/react';
import { X } from '@phosphor-icons/react/dist/ssr';
import { shopTestId } from '@utils/utils-shop-test-ids';
import { useAtom } from 'jotai';
import Link from 'next/link';
import { useAppSession } from 'src/lib/auth/client/app-session-provider';
import { HOTEL_ADS_NAV_ORDER, hotelAdsCriticalPath } from 'src/lib/hotel-ads/nav';
import { AddedToCartItem } from './added-to-cart-item';
import { AddedToCartRecommendation } from './added-to-cart-recommendation';
import { addedToCartItemsAtom } from './atoms/added-to-cart-items.atom';
type AddedToCartProps = {
  recommendation: GetRecommendationFragment | null | undefined;
};
export function AddedToCart(t0) {
  const $ = _c(11);
  const {
    recommendation
  } = t0;
  const {
    loading,
    user
  } = useAppSession();
  const [addedToCartItems, setAddedToCartItems] = useAtom(addedToCartItemsAtom);
  const checkoutUrl = loading || user ? "/checkout" : "/checkout/guest-signup";
  let t1;
  if ($[0] !== setAddedToCartItems) {
    t1 = () => {
      setAddedToCartItems(null);
    };
    $[0] = setAddedToCartItems;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClose = t1;
  const t2 = !!addedToCartItems;
  let t3;
  if ($[2] !== addedToCartItems || $[3] !== checkoutUrl || $[4] !== handleClose || $[5] !== recommendation) {
    t3 = () => <div className="flex w-full flex-col"><div className="mb-4 flex flex-row items-center"><CheckCircle size={32} className="text-success" weight="fill" /><h4 className="ml-4 font-heading4-small">Im Warenkorb</h4><IconButton data-testid={shopTestId("AddedToCart.close")} Icon={X} onClick={handleClose} className="ml-auto" weight="ghost" aria-label={"Dialog schlie\xDFen"} /></div>{addedToCartItems?.map(_temp)}<div className="mt-4 flex w-full xs:flex-row flex-col-reverse gap-4"><Button full={true} variant="secondary" as={Link} href="/cart" data-testid={shopTestId("AddedToCart.view-cart")} onClick={_temp2} {...hotelAdsCriticalPath(HOTEL_ADS_NAV_ORDER.viewCart)}>Zum Warenkorb</Button><Button full={true} as={Link} href={checkoutUrl} data-testid={shopTestId("AddedToCart.to-checkout")} onClick={_temp3}>Direkt bezahlen</Button></div><AddedToCartRecommendation recommendation={recommendation} startDate={addedToCartItems?.[0]?.startDate} endDate={addedToCartItems?.[0]?.endDate} /></div>;
    $[2] = addedToCartItems;
    $[3] = checkoutUrl;
    $[4] = handleClose;
    $[5] = recommendation;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== handleClose || $[8] !== t2 || $[9] !== t3) {
    t4 = <Popup onClose={handleClose} isOpen={t2} renderContent={t3} />;
    $[7] = handleClose;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp3() {
  return trackClickCta("to checkout", {
    type: "pdp - basket overlay"
  });
}
function _temp2() {
  return trackClickCta("to cart", {
    type: "pdp - basket overlay"
  });
}
function _temp(item) {
  return <AddedToCartItem key={`${item.type}-${item.name}-${item.startDate}-${item.endDate ?? ""}`} item={item} />;
}